import { render, staticRenderFns } from "./NwFormBt.vue?vue&type=template&id=4e2a9147&scoped=true&"
import script from "./NwFormBt.vue?vue&type=script&lang=js&"
export * from "./NwFormBt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2a9147",
  null
  
)

export default component.exports